import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PreOrderComponent } from '@pages/partbnb-component';

export const routes: Routes = [
  {
    path: '',
    component: PreOrderComponent,
    data: {
      moduleName: 'signup',
      pageTitle: 'Partbnb - Sign Up',
      pageName: 'My Properties'
    }
  },
  { path: '**', component: PreOrderComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SignUpRoutingModule {}
